var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserX01Primery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 10.6667L14.333 14M14.333 10.6667L10.9997 14M7.99967 10.3333H4.99968C4.0693 10.3333 3.60411 10.3333 3.22558 10.4482C2.37331 10.7067 1.70637 11.3736 1.44783 12.2259C1.33301 12.6044 1.33301 13.0696 1.33301 14M9.66634 5C9.66634 6.65685 8.3232 8 6.66634 8C5.00949 8 3.66634 6.65685 3.66634 5C3.66634 3.34315 5.00949 2 6.66634 2C8.3232 2 9.66634 3.34315 9.66634 5Z",
    stroke: "#4C60E5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserX01Primery);
export default __webpack_public_path__ + "static/media/user-x-01-primery.ac03f609f6a01c0789181fc6e465daa0.svg";
export { ForwardRef as ReactComponent };